webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3EZy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3L0a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5E/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9O0A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B2D2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D32g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I/4D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IafB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K3XW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d9a7f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('router-view',{attrs:{"name":"layout"}},[_c('router-view',{attrs:{"name":"content"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("hrNr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ce7212","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Dialogue.vue
var Dialogue_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogue"},[_vm._t("default")],2)}
var Dialogue_staticRenderFns = []
var Dialogue_esExports = { render: Dialogue_render, staticRenderFns: Dialogue_staticRenderFns }
/* harmony default export */ var Dialogue = (Dialogue_esExports);
// CONCATENATED MODULE: ./src/layouts/Dialogue.vue
function Dialogue_injectStyle (ssrContext) {
  __webpack_require__("K3XW")
}
var Dialogue_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var Dialogue___vue_template_functional__ = false
/* styles */
var Dialogue___vue_styles__ = Dialogue_injectStyle
/* scopeId */
var Dialogue___vue_scopeId__ = "data-v-63ce7212"
/* moduleIdentifier (server only) */
var Dialogue___vue_module_identifier__ = null
var Dialogue_Component = Dialogue_normalizeComponent(
  __vue_script__,
  Dialogue,
  Dialogue___vue_template_functional__,
  Dialogue___vue_styles__,
  Dialogue___vue_scopeId__,
  Dialogue___vue_module_identifier__
)

/* harmony default export */ var layouts_Dialogue = (Dialogue_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196d970c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Centered.vue
var Centered_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_vm._t("default")],2)}
var Centered_staticRenderFns = []
var Centered_esExports = { render: Centered_render, staticRenderFns: Centered_staticRenderFns }
/* harmony default export */ var Centered = (Centered_esExports);
// CONCATENATED MODULE: ./src/layouts/Centered.vue
function Centered_injectStyle (ssrContext) {
  __webpack_require__("I/4D")
}
var Centered_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Centered___vue_script__ = null
/* template */

/* template functional */
var Centered___vue_template_functional__ = false
/* styles */
var Centered___vue_styles__ = Centered_injectStyle
/* scopeId */
var Centered___vue_scopeId__ = "data-v-196d970c"
/* moduleIdentifier (server only) */
var Centered___vue_module_identifier__ = null
var Centered_Component = Centered_normalizeComponent(
  Centered___vue_script__,
  Centered,
  Centered___vue_template_functional__,
  Centered___vue_styles__,
  Centered___vue_scopeId__,
  Centered___vue_module_identifier__
)

/* harmony default export */ var layouts_Centered = (Centered_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./src/config/privacy_changes.js

/**
 * Change log for the privacy notice in reverse chronological order,
 * meaning last update first
 */
var privacyNoticeUpdates = [{
  date: '2018-05-24',
  notice: ['In order to comply with the General Data Protection Regulation (GDPR)\n      we\'ve established this privacy notice informing you of our practices\n      regarding the protection of your personal data.']
}];

var privacyNoticeDate = privacyNoticeUpdates[0].date;
// CONCATENATED MODULE: ./src/config/index.js


var userPoolId = "eu-west-1_MJbMhvGjX";
var appClientId = "3gcqe1vg36bs1f30v5bvj6fdgi";
var routerMode = "history";
var clientName = "id.welix.no";
var logsink = "https://logsink.svc.welix.no";

var validCallbacks = "/^https:\/\/[a-z-]+\\.(admin|api)(\\.staging)?\\.welix\\.no\/sso\/result/i".split(';').map(function (url) {
  var regexp = /^\/(.*)\/([^/]*$)/.exec(url);
  if (regexp) {
    return new RegExp(regexp[1], regexp[2]);
  }
  return url;
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/logger/index.js






function post(data) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', logsink);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.send(stringify_default()(data));

  return function (f) {
    var done = false;
    var trigger = function trigger() {
      if (done) return;
      done = true;
      f();
    };

    xhr.onload = trigger;
    xhr.onabort = trigger;
    xhr.onerror = trigger;
    xhr.ontimeout = trigger;
  };
}

function processException(_ref) {
  var name = _ref.name,
      message = _ref.message,
      stack = _ref.stack;

  return {
    message: message,
    type: name,
    stackTrace: stack
  };
}

function logger_log(_ref2) {
  var scope = _ref2.scope,
      severity = _ref2.severity,
      message = _ref2.message,
      exception = _ref2.exception;

  var schedule = null;
  var ready = true;

  if (!message || typeof message !== 'string') ready = false;
  if (scope !== undefined && typeof scope !== 'string') ready = false;
  if (exception !== undefined && !(exception instanceof Error)) ready = false;

  // just ignore if params are not valid
  if (ready) {
    var payload = {
      scope: scope,
      severity: severity,
      message: message,
      user: getCurrentUserId(),
      exception: exception && processException(exception),
      client: clientName
    };

    if (logsink) schedule = post(payload);
    // eslint-disable-next-line no-console
    else console.log(payload);
  }

  return {
    then: function then(f) {
      return schedule ? schedule(f) : f();
    }
  };
}

function createLogger(scope) {
  return {
    trace: function trace(_ref3) {
      var args = objectWithoutProperties_default()(_ref3, []);

      return logger_log(extends_default()({}, args, { scope: scope, severity: 'Trace' }));
    },
    debug: function debug(_ref4) {
      var args = objectWithoutProperties_default()(_ref4, []);

      return logger_log(extends_default()({}, args, { scope: scope, severity: 'Debug' }));
    },
    information: function information(_ref5) {
      var args = objectWithoutProperties_default()(_ref5, []);

      return logger_log(extends_default()({}, args, { scope: scope, severity: 'Information' }));
    },
    warning: function warning(_ref6) {
      var args = objectWithoutProperties_default()(_ref6, []);

      return logger_log(extends_default()({}, args, { scope: scope, severity: 'Warning' }));
    },
    error: function error(_ref7) {
      var args = objectWithoutProperties_default()(_ref7, []);

      return logger_log(extends_default()({}, args, { scope: scope, severity: 'Error' }));
    },
    critical: function critical(_ref8) {
      var args = objectWithoutProperties_default()(_ref8, []);

      return logger_log(extends_default()({}, args, { scope: scope, severity: 'Critical' }));
    }
  };
}

/* harmony default export */ var logger = (createLogger());
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/amazon-cognito-identity-js/es/index.js + 14 modules
var es = __webpack_require__("2DBr");

// CONCATENATED MODULE: ./src/auth/cognito.js




var userPool = new es["d" /* CognitoUserPool */]({
  UserPoolId: userPoolId,
  ClientId: appClientId
});

var cognito_createUser = function createUser(Username) {
  return new es["b" /* CognitoUser */]({ Username: Username, Pool: userPool });
};

var cognito_createCredentials = function createCredentials(Username, Password) {
  return new es["a" /* AuthenticationDetails */]({ Username: Username, Password: Password });
};

var getCurrentUser = function getCurrentUser() {
  return userPool.getCurrentUser();
};

function refreshSession(_ref) {
  var success = _ref.success,
      error = _ref.error,
      user = _ref.user,
      session = _ref.session;

  user.refreshSession(session.getRefreshToken(), function (err, refreshedSession) {
    if (err) error(err);else success({ user: user, session: refreshedSession });
  });
}

var getAuthenticatedUser = function getAuthenticatedUser(_ref2) {
  var success = _ref2.success,
      error = _ref2.error,
      minValidSeconds = _ref2.minValidSeconds;

  var user = getCurrentUser();

  if (!user) {
    var e = new Error('No current user');
    e.code = 'WXNotAuthenticated';
    error(e);
    return;
  }

  user.getSession(function (err, session) {
    if (err) {
      return error(err);
    }

    if (minValidSeconds) {
      var expires = session.getAccessToken().getExpiration();
      var now = Math.floor(Date.now() / 1000);

      if (expires < now + minValidSeconds) {
        return refreshSession({ user: user, session: session, success: success, error: error });
      }
    }

    return success({ user: user, session: session });
  });
};

var refreshCredentials = function refreshCredentials(_ref3) {
  var _success = _ref3.success,
      error = _ref3.error;

  getAuthenticatedUser({
    error: error,
    success: function success(_ref4) {
      var user = _ref4.user,
          session = _ref4.session;
      return refreshSession({ user: user, session: session, success: _success, error: error });
    }
  });
};

var cognito_userAttributesFromHash = function userAttributesFromHash(hash) {
  return keys_default()(hash).map(function (key) {
    return new es["c" /* CognitoUserAttribute */]({ Name: key, Value: hash[key] });
  });
};

var attributesToHash = function attributesToHash(attrs) {
  var hash = {};
  attrs.forEach(function (attr) {
    hash[attr.Name] = attr.Value;
  });
  return hash;
};
// CONCATENATED MODULE: ./src/auth/login.js



var login_log = createLogger('auth.login');

function errorToFriendlyMessage(err) {
  if (err.code === 'PasswordResetRequiredException') {
    login_log.information({ message: 'Password reset required for user.' });
    return 'A password reset is required before you can log in.';
  }

  if (err.code === 'UserNotFoundException') {
    login_log.debug({ message: 'Login attempt for unknown email.' });
    return 'No user with that email.';
  }

  if (err.code === 'NotAuthorizedException') {
    login_log.debug({ message: 'Login attempt with incorrect password.' });
    return 'Incorrect password.';
  }

  login_log.error({
    message: 'Encountered unmatched error during login.',
    exception: err
  });

  return err.message;
}

function login(_ref) {
  var username = _ref.username,
      password = _ref.password,
      success = _ref.success,
      error = _ref.error,
      forcepw = _ref.forcepw;

  var user = cognito_createUser(username);

  user.authenticateUser(cognito_createCredentials(username, password), {
    onSuccess: function onSuccess(res) {
      login_log.information({ message: 'User logged in.' });
      success(res.getIdToken().getJwtToken());
    },

    onFailure: function onFailure(err) {
      return error(errorToFriendlyMessage(err));
    },

    newPasswordRequired: function newPasswordRequired() {
      login_log.information({
        message: 'First login attempt for admin-created user. Extra information required.'
      });

      forcepw(function (_ref2) {
        var newPassword = _ref2.newPassword,
            given_name = _ref2.given_name,
            family_name = _ref2.family_name;

        var attrs = { given_name: given_name, family_name: family_name };

        login_log.information({
          message: 'Updating information for admin-created user.'
        });

        user.completeNewPasswordChallenge(newPassword, attrs, {
          onSuccess: function onSuccess(res) {
            return success(res.getIdToken().getJwtToken());
          },
          onFailure: function onFailure(err) {
            return error(errorToFriendlyMessage(err));
          }
        });
      });
    }
  });
}
// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__("GCDA");
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);

// EXTERNAL MODULE: ./node_modules/timeago.js/dist/timeago.min.js
var timeago_min = __webpack_require__("8A1c");
var timeago_min_default = /*#__PURE__*/__webpack_require__.n(timeago_min);

// CONCATENATED MODULE: ./src/auth/errors.js
/**
 * Parse errors from cognito and supply useful messages to the user.
 * Assumes that the user has a valid session (e.g an authorized route).
 *
 * Expects a scoped logger to be passed along with the error.
 */
function errors_errorToFriendlyMessage(error, log) {
  if (error.code === 'UserNotFoundException') {
    log.warning({
      message: 'User account not found while in authenticated context.',
      exception: error
    });
    return 'Your user account has been deleted, probably by you. ' + 'Contact support if you find this strange.';
  }

  if (error.code === 'NotAuthorizedException' && /disabled/.test(error.message)) {
    log.warning({
      message: 'User account disabled while in authenticated context.',
      exception: error
    });
    return 'Your user account has been disabled, contact support to find out why.';
  }

  if (error.code === 'NotAuthorizedException' && /revoked/.test(error.message)) {
    log.information({
      message: 'User session revoked while in authenticated context.',
      exception: error
    });
    return 'Your session has been invalidated, probably by you.';
  }

  if (error.code === 'WXNotAuthenticated') {
    log.information({
      message: 'Access attempt denied because the user was not authenticated',
      exception: error
    });
    return 'Your request was denied because you are not logged in.';
  }

  log.error({
    message: 'Encountered unmatched error in authenticated context.',
    exception: error
  });

  return error.message;
}
// CONCATENATED MODULE: ./src/auth/session.js











var session_log = createLogger('auth.session');

function parseSessionsResult(devices) {
  var time = timeago_min_default()().format;
  var sessions = devices.map(function (dev) {
    var attrs = attributesToHash(dev.DeviceAttributes);
    var ua = ua_parser_default()(attrs.device_name);

    return {
      key: dev.DeviceKey,
      lastIp: attrs.last_ip_used,
      signedIn: attrs.device_status === 'valid',
      lastLogin: dev.DeviceLastAuthenticatedDate,
      lastLoginRelative: time(dev.DeviceLastAuthenticatedDate),
      firstUsed: dev.DeviceCreateDate,
      firstUsedRelative: time(dev.DeviceCreateDate),
      device: {
        os: ua.os.name,
        browser: ua.browser.name,
        browserVersion: ua.browser.major,
        type: ua.device.type,
        model: ua.device.model
      }
    };
  });

  return sessions.sort(function (a, b) {
    return a.lastLogin < b.lastLogin;
  });
}

function getListSegment(user, count, token, error, success) {
  user.listDevices(count, token, {
    onFailure: function onFailure(err) {
      return error(errors_errorToFriendlyMessage(err, session_log));
    },
    onSuccess: function onSuccess(_ref) {
      var Devices = _ref.Devices,
          PaginationToken = _ref.PaginationToken;

      success({
        sessions: parseSessionsResult(Devices),
        fetchMore: !PaginationToken ? false : function () {
          return getListSegment(user, count, PaginationToken, error, success);
        }
      });
    }
  });
}

// get user name (guid) synchronously if available.
// Email is not available without async operations.
function getCurrentUserId() {
  return (getCurrentUser() || {}).username;
}

function isAuthenticated(cb) {
  getAuthenticatedUser({
    success: function success(_ref2) {
      var session = _ref2.session;
      return cb(session.isValid());
    },
    error: function error() {
      return cb(false);
    }
  });
}

function getIdToken(_ref3) {
  var _success = _ref3.success,
      _error = _ref3.error,
      minValidSeconds = _ref3.minValidSeconds;

  getAuthenticatedUser({
    minValidSeconds: minValidSeconds,
    error: function error(err) {
      return _error(errors_errorToFriendlyMessage(err, session_log));
    },
    success: function success(_ref4) {
      var session = _ref4.session;

      session_log.trace({ message: 'Retrieved new Id token.' });
      _success(session.getIdToken().getJwtToken());
    }
  });
}

function getAccessToken(_ref5) {
  var _success2 = _ref5.success,
      _error2 = _ref5.error,
      minValidSeconds = _ref5.minValidSeconds;

  getAuthenticatedUser({
    minValidSeconds: minValidSeconds,
    error: function error(err) {
      return _error2(errors_errorToFriendlyMessage(err, session_log));
    },
    success: function success(_ref6) {
      var session = _ref6.session;

      session_log.trace({ message: 'Retrieved new Access token.' });
      _success2(session.getAccessToken().getJwtToken());
    }
  });
}

function listSessions(_ref7) {
  var _success3 = _ref7.success,
      _error3 = _ref7.error,
      count = _ref7.count;

  getAuthenticatedUser({
    error: function error(err) {
      return _error3(errors_errorToFriendlyMessage(err, session_log));
    },
    success: function success(_ref8) {
      var user = _ref8.user;
      return getListSegment(user, count || 10, null, _error3, _success3);
    }
  });
}
// CONCATENATED MODULE: ./src/auth/logout.js






var logout_log = createLogger('auth.logout');

function forgetAllSessions(user, next) {
  var noop = {
    onSuccess: function onSuccess() {},
    onFailure: function onFailure() {}
  };

  listSessions({
    count: 50,
    error: next,
    success: function success(_ref) {
      var sessions = _ref.sessions,
          fetchMore = _ref.fetchMore;

      sessions.forEach(function (session) {
        return user.forgetSpecificDevice(session.key, noop);
      });
      if (fetchMore) {
        fetchMore();
      } else {
        next();
      }
    }
  });
}

function logout() {
  var user = getCurrentUser();

  if (user) {
    logout_log.information({ message: 'User logged out.' });
    user.signOut();
  }
}

function globalLogout(_ref2) {
  var _success = _ref2.success,
      _error = _ref2.error;

  getAuthenticatedUser({
    error: function error(err) {
      return _error(errors_errorToFriendlyMessage(err, logout_log));
    },
    success: function success(_ref3) {
      var user = _ref3.user;

      // forget sessions before clearing tokens (session must be valid)
      forgetAllSessions(user, function () {
        // then sign out
        logout_log.information({ message: 'User invalidated all sessions.' });
        user.globalSignOut({
          onFailure: function onFailure(err) {
            return _error(errors_errorToFriendlyMessage(err, logout_log));
          },
          onSuccess: function onSuccess() {
            logout();
            _success();
          }
        });
      });
    }
  });
}
// CONCATENATED MODULE: ./src/auth/signup.js




var signup_log = createLogger('auth.signup');

function guid(a) {
  return a ?
  //eslint-disable-next-line
  (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, guid);
}

function signup_errorToFriendlyMessage(err, email) {
  if (err.code === 'AliasExistsException') {
    signup_log.warning({
      message: 'Signup attempt with existing email: "' + email + '".'
    });

    return 'There is already an account with the email you provided, ' + 'perhaps you\'d like to reset your password?';
  }

  if (err.code === 'CodeMismatchException') {
    return 'Sorry, that code was invalid. Please try again.';
  }

  signup_log.error({
    message: 'Encountered unmatched error during signup with email: "' + email + '"',
    exception: err
  });

  return err.message;
}

function callback(email, error, success) {
  return function (err, res) {
    return err ? error(signup_errorToFriendlyMessage(err, email)) : success(res);
  };
}

function signup_signup(_ref) {
  var email = _ref.email,
      password = _ref.password,
      given_name = _ref.given_name,
      family_name = _ref.family_name,
      consent_date = _ref.consent_date,
      success = _ref.success,
      error = _ref.error,
      verificationRequired = _ref.verificationRequired;

  var awsAttrs = cognito_userAttributesFromHash({
    email: email,
    given_name: given_name,
    family_name: family_name,
    'custom:consent_date': consent_date
  });

  var cb = callback(email, error, function (res) {
    var user = res.user;

    signup_log.information({
      message: 'User account "' + email + '" pending verification.'
    });

    verificationRequired(function (_ref2) {
      var code = _ref2.code;

      user.confirmRegistration(code, false, callback(email, error, function () {
        signup_log.information({
          message: 'User account "' + email + '" successfully verified.'
        });

        success();
      }));
    });
  });

  userPool.signUp(guid(), password, awsAttrs, null, cb);
}
// CONCATENATED MODULE: ./src/auth/delete.js






var delete_log = createLogger('auth.delete');

function delete_deleteUser(_ref) {
  var error = _ref.error,
      _success = _ref.success;

  getAuthenticatedUser({
    error: function error(err) {
      return errors_errorToFriendlyMessage(err, delete_log);
    },
    success: function success(_ref2) {
      var user = _ref2.user;
      return user.deleteUser(function (err) {
        if (err) {
          error(errors_errorToFriendlyMessage(err, delete_log));
        } else {
          delete_log.information({ message: 'User account deleted!' });
          logout();
          _success();
        }
      });
    }
  });
}
// CONCATENATED MODULE: ./src/auth/reset.js



var reset_log = createLogger('auth.reset');

function reset_errorToFriendlyMessage(err) {
  if (err.code === 'UserNotFoundException') {
    return 'No user with that email.';
  }

  reset_log.error({
    message: 'Encountered unmatched error during password reset.',
    exception: err
  });

  return err.message;
}

function requestReset(_ref) {
  var username = _ref.username,
      success = _ref.success,
      error = _ref.error;

  var user = cognito_createUser(username);

  user.forgotPassword({
    onSuccess: function onSuccess() {
      reset_log.information({ message: 'Password reset request for ' + username + '.' });
      success();
    },
    onFailure: function onFailure(err) {
      return error(reset_errorToFriendlyMessage(err));
    }
  });
}

function completeReset(_ref2) {
  var username = _ref2.username,
      code = _ref2.code,
      password = _ref2.password,
      success = _ref2.success,
      error = _ref2.error;

  var user = cognito_createUser(username);

  user.confirmPassword(code, password, {
    onSuccess: function onSuccess() {
      reset_log.information({ message: 'Password reset completed for ' + username + '.' });
      success();
    },
    onFailure: function onFailure(err) {
      return error(reset_errorToFriendlyMessage(err));
    }
  });
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./src/auth/profile.js








var profile_log = createLogger('auth.profile');

function getProfileAttributes(_ref) {
  var attrs = _ref.attrs,
      success = _ref.success,
      error = _ref.error;

  var handleError = function handleError(err) {
    return error(errors_errorToFriendlyMessage(err, profile_log));
  };
  var resultHandler = function resultHandler(err, res) {
    if (err) return handleError(err);

    var profile = attributesToHash(res);
    var out = assign_default.a.apply(Object, [{}].concat(toConsumableArray_default()(attrs.map(function (key) {
      return defineProperty_default()({}, key, profile[key]);
    }))));

    profile_log.information({
      message: attrs.reduce(function (acc, key) {
        return acc + ' ' + key + '=' + out[key];
      }, 'Retrieved profile data:')
    });

    return success(out);
  };

  getAuthenticatedUser({
    error: handleError,
    success: function success(_ref3) {
      var user = _ref3.user;
      return user.getUserAttributes(resultHandler);
    }
  });
}

function setProfileAttributes(_ref4) {
  var attrs = _ref4.attrs,
      _success = _ref4.success,
      error = _ref4.error;

  var handleError = function handleError(err) {
    return error(errors_errorToFriendlyMessage(err, profile_log));
  };

  getAuthenticatedUser({
    error: handleError,
    success: function success(_ref5) {
      var user = _ref5.user;

      profile_log.information({
        message: attrs.reduce(function (acc, _ref6) {
          var Name = _ref6.Name,
              Value = _ref6.Value;
          return acc + ' ' + Name + '=' + Value;
        }, 'Updating profile:')
      });
      user.updateAttributes(attrs, function (err) {
        if (err) handleError(err);
        // fetch new tokens to avoid stale data in payload
        else refreshCredentials({ success: _success, error: handleError });
      });
    }
  });
}

function getUserProfile(_ref7) {
  var success = _ref7.success,
      error = _ref7.error;

  getProfileAttributes({
    success: success,
    error: error,
    attrs: ['email', 'given_name', 'family_name', 'email_verified']
  });
}

function getConsentDate(cb) {
  getAuthenticatedUser({
    success: function success(_ref8) {
      var session = _ref8.session;
      return cb(session.idToken.payload['custom:consent_date']);
    },
    error: function error() {
      return cb(null);
    }
  });
}

/**
 * Does not accept email as a property to update due to upstream
 */
function setUserProfile(_ref9) {
  var given_name = _ref9.given_name,
      family_name = _ref9.family_name,
      success = _ref9.success,
      error = _ref9.error;

  setProfileAttributes({
    success: success,
    error: error,
    attrs: cognito_userAttributesFromHash({ given_name: given_name, family_name: family_name })
  });
}

function setConsentDate(_ref10) {
  var consent_date = _ref10.consent_date,
      success = _ref10.success,
      error = _ref10.error;

  setProfileAttributes({
    error: error,
    success: success,
    attrs: cognito_userAttributesFromHash({ 'custom:consent_date': consent_date })
  });
}
// CONCATENATED MODULE: ./src/auth/index.js









// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abe31a1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Heading.vue
var Heading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"h1"},[_vm._t("default")],2)}
var Heading_staticRenderFns = []
var Heading_esExports = { render: Heading_render, staticRenderFns: Heading_staticRenderFns }
/* harmony default export */ var Heading = (Heading_esExports);
// CONCATENATED MODULE: ./src/components/elements/Heading.vue
function Heading_injectStyle (ssrContext) {
  __webpack_require__("dhOH")
}
var Heading_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Heading___vue_script__ = null
/* template */

/* template functional */
var Heading___vue_template_functional__ = false
/* styles */
var Heading___vue_styles__ = Heading_injectStyle
/* scopeId */
var Heading___vue_scopeId__ = "data-v-2abe31a1"
/* moduleIdentifier (server only) */
var Heading___vue_module_identifier__ = null
var Heading_Component = Heading_normalizeComponent(
  Heading___vue_script__,
  Heading,
  Heading___vue_template_functional__,
  Heading___vue_styles__,
  Heading___vue_scopeId__,
  Heading___vue_module_identifier__
)

/* harmony default export */ var elements_Heading = (Heading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/FormButton.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var FormButton = ({
  directives: {
    focus: {
      inserted: function inserted(el, binding) {
        if (binding.value) el.focus();
      },

      componentUpdated: function componentUpdated(el, binding) {
        if (binding.value && !binding.oldValue) el.focus();
      }
    }
  },

  props: {
    pull: String,
    color: String,
    focus: Boolean
  },

  computed: {
    classes: function classes() {
      var out = ['btn'];

      if (this.pull === 'right' || this.pull === 'left') {
        out.push('pull-' + this.pull);
      }

      if (this.color) {
        out.push('btn-' + this.color);
      }

      return out;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd639670","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FormButton.vue
var FormButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.focus),expression:"focus"}],class:_vm.classes,on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default")],2)}
var FormButton_staticRenderFns = []
var FormButton_esExports = { render: FormButton_render, staticRenderFns: FormButton_staticRenderFns }
/* harmony default export */ var elements_FormButton = (FormButton_esExports);
// CONCATENATED MODULE: ./src/components/elements/FormButton.vue
function FormButton_injectStyle (ssrContext) {
  __webpack_require__("9O0A")
}
var FormButton_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FormButton___vue_template_functional__ = false
/* styles */
var FormButton___vue_styles__ = FormButton_injectStyle
/* scopeId */
var FormButton___vue_scopeId__ = "data-v-dd639670"
/* moduleIdentifier (server only) */
var FormButton___vue_module_identifier__ = null
var FormButton_Component = FormButton_normalizeComponent(
  FormButton,
  elements_FormButton,
  FormButton___vue_template_functional__,
  FormButton___vue_styles__,
  FormButton___vue_scopeId__,
  FormButton___vue_module_identifier__
)

/* harmony default export */ var components_elements_FormButton = (FormButton_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-float-label/components/FloatLabel.vue + 2 modules
var FloatLabel = __webpack_require__("kAsg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/FormField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var FormField = ({
  components: {
    'float-label': FloatLabel["a" /* default */]
  },

  directives: {
    focus: {
      inserted: function inserted(el, binding) {
        if (binding.value) el.focus();
      },

      componentUpdated: function componentUpdated(el, binding) {
        if (binding.value && !binding.oldValue) el.focus();
      }
    }
  },

  props: {
    validate: { type: [RegExp, Function] },
    type: { type: String, default: 'text' },
    label: { type: String },
    value: { type: String, default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    focus: { type: Boolean, default: false }
  },

  data: function data() {
    return {
      valid: true,
      touched: false,
      current_value: this.value
    };
  },


  computed: {
    stripped: function stripped() {
      return this.current_value.replace(/^\s+|\s+$/g, '');
    }
  },

  watch: {
    stripped: function stripped() {
      this.doValidate();
      this.$emit('input', this.valid ? this.stripped : '');
    },
    touched: function touched() {
      this.doValidate();
    }
  },

  methods: {
    doValidate: function doValidate() {
      var value = this.stripped;
      this.valid = true;

      if (value.length || this.touched && this.required) {
        this.valid = !!value.length;

        if (typeof this.validate === 'function') {
          this.valid = this.validate(value);
        } else if (this.validate instanceof RegExp) {
          this.valid = this.validate.test(value);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcd5e38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FormField.vue
var FormField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('float-label',{class:{ error: !_vm.valid }},[_c('input',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.focus),expression:"focus"}],attrs:{"type":_vm.type,"placeholder":_vm.label,"disabled":_vm.disabled},domProps:{"value":_vm.current_value},on:{"input":function($event){_vm.current_value = $event.target.value},"focus":function($event){_vm.touched = true},"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.$emit('submit', true)}}})])}
var FormField_staticRenderFns = []
var FormField_esExports = { render: FormField_render, staticRenderFns: FormField_staticRenderFns }
/* harmony default export */ var elements_FormField = (FormField_esExports);
// CONCATENATED MODULE: ./src/components/elements/FormField.vue
function FormField_injectStyle (ssrContext) {
  __webpack_require__("eaxF")
  __webpack_require__("3EZy")
}
var FormField_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FormField___vue_template_functional__ = false
/* styles */
var FormField___vue_styles__ = FormField_injectStyle
/* scopeId */
var FormField___vue_scopeId__ = "data-v-3bcd5e38"
/* moduleIdentifier (server only) */
var FormField___vue_module_identifier__ = null
var FormField_Component = FormField_normalizeComponent(
  FormField,
  elements_FormField,
  FormField___vue_template_functional__,
  FormField___vue_styles__,
  FormField___vue_scopeId__,
  FormField___vue_module_identifier__
)

/* harmony default export */ var components_elements_FormField = (FormField_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/FormMessage.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FormMessage = ({
  props: {
    message: { type: String, default: '' },
    severity: { type: String, default: 'information' }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235a9776","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FormMessage.vue
var FormMessage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message || _vm.$slots.default)?_c('p',{class:[ 'message', _vm.severity ]},[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],2):_vm._e()}
var FormMessage_staticRenderFns = []
var FormMessage_esExports = { render: FormMessage_render, staticRenderFns: FormMessage_staticRenderFns }
/* harmony default export */ var elements_FormMessage = (FormMessage_esExports);
// CONCATENATED MODULE: ./src/components/elements/FormMessage.vue
function FormMessage_injectStyle (ssrContext) {
  __webpack_require__("IafB")
}
var FormMessage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FormMessage___vue_template_functional__ = false
/* styles */
var FormMessage___vue_styles__ = FormMessage_injectStyle
/* scopeId */
var FormMessage___vue_scopeId__ = "data-v-235a9776"
/* moduleIdentifier (server only) */
var FormMessage___vue_module_identifier__ = null
var FormMessage_Component = FormMessage_normalizeComponent(
  FormMessage,
  elements_FormMessage,
  FormMessage___vue_template_functional__,
  FormMessage___vue_styles__,
  FormMessage___vue_scopeId__,
  FormMessage___vue_module_identifier__
)

/* harmony default export */ var components_elements_FormMessage = (FormMessage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Profile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Profile = ({
  components: {
    Heading: elements_Heading,
    FormButton: components_elements_FormButton,
    FormField: components_elements_FormField,
    FormMessage: components_elements_FormMessage
  },

  data: function data() {
    return {
      privacyNoticeUpdated: false,
      deleteConfirmed: false,
      profile: {},
      sessions: [],
      fetchMoreSessions: null,
      sessionsError: null,
      finalMessage: null
    };
  },
  created: function created() {
    var _this = this;

    getConsentDate(function (date) {
      _this.privacyNoticeUpdated = !date || privacyNoticeDate > date;
    });

    getUserProfile({
      success: function success(result) {
        _this.profile = result;
      },
      error: function error(_error) {
        _this.finalMessage = {
          error: _error,
          heading: 'Profile error'
        };
      }
    });

    listSessions({
      count: 10,
      success: function success(_ref) {
        var _sessions;

        var sessions = _ref.sessions,
            fetchMore = _ref.fetchMore;

        (_sessions = _this.sessions).push.apply(_sessions, toConsumableArray_default()(sessions));
        _this.fetchMoreSessions = fetchMore;
      },
      error: function error(_error2) {
        _this.sessionsError = _error2;
      }
    });
  },


  props: {
    email: { type: String, default: '' }
  },

  computed: {
    msgSeverity: function msgSeverity() {
      return this.error ? 'warning' : 'information';
    }
  },

  methods: {
    clearSessions: function clearSessions() {
      var _this2 = this;

      globalLogout({
        error: function error(_error3) {
          _this2.finalMessage = {
            error: _error3,
            heading: 'Sign out failed'
          };
        },
        success: function success() {
          _this2.finalMessage = {
            heading: 'Signed out',
            text: 'All sessions have been invalidated.'
          };
        }
      });
    },
    deleteUser: function deleteUser() {
      var _this3 = this;

      delete_deleteUser({
        error: function error(_error4) {
          _this3.finalMessage = {
            error: _error4,
            heading: 'Delete failed'
          };
        },
        success: function success() {
          _this3.finalMessage = {
            heading: 'Account deleted',
            text: 'Your account has been deleted and all permissions are now revoked.'
          };
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9171f742","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finalMessage)?_c('div',[_c('heading',[_c('small',[_vm._v(_vm._s(_vm.finalMessage.heading))])]),_vm._v(" "),(_vm.finalMessage.error)?_c('form-message',{attrs:{"severity":"warning"}},[_vm._v("\n    Whoops, you've found an error:\n\n    "),_c('code',{staticClass:"error-message"},[_vm._v("\n      "+_vm._s(_vm.finalMessage.error)+"\n    ")]),_vm._v("\n\n    This might be our fault, if so we are sorry.\n  ")]):_vm._e(),_vm._v(" "),(_vm.finalMessage.error)?_c('p',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/logout"}},[_vm._v("Signing in again")]),_vm._v(" might help.\n  ")],1):_c('form-message',{attrs:{"severity":"information"}},[_vm._v("\n    "+_vm._s(_vm.finalMessage.text || '')+"\n    Open WElix sessions will expire soon but you can end them now by clicking\n    log out in the application if you prefer.\n  ")])],1):_c('div',{staticClass:"account"},[_c('heading',[_c('small',[_vm._v("My account")])]),_vm._v(" "),(_vm.privacyNoticeUpdated)?_c('form-message',{attrs:{"severity":"information"}},[_vm._v("\n    The privacy notice has changed since your last review. Click\n    "),_c('router-link',{attrs:{"to":"/ask-consent"}},[_vm._v("here")]),_vm._v(" to review and consent to\n    the updated notice.\n  ")],1):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"section"},[_vm._v("Profile")]),_vm._v(" "),_c('table',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Email / login:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.profile.email))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Name:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.profile.given_name)+" "+_vm._s(_vm.profile.family_name))])])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('form-button',{on:{"click":function($event){_vm.$router.push('/logout')}}},[_vm._v("\n      Sign out\n    ")]),_vm._v(" "),_c('form-button',{on:{"click":function($event){_vm.$router.push('/edit')}}},[_vm._v("\n      Edit profile\n    ")]),_vm._v(" "),_c('form-button',{on:{"click":function($event){_vm.$router.push(("/reset/" + (_vm.profile.email)))}}},[_vm._v("\n      Change password\n    ")]),_vm._v(" "),(_vm.privacyNoticeUpdated)?_c('form-button',{attrs:{"color":"blue"},on:{"click":function($event){_vm.$router.push('/ask-consent')}}},[_vm._v("\n      Review updated privacy notice\n    ")]):_c('form-button',{on:{"click":function($event){_vm.$router.push('/privacy-notice')}}},[_vm._v("\n      View privacy notice\n    ")])],1),_vm._v(" "),_c('h2',{staticClass:"section"},[_vm._v("Recent/active sessions")]),_vm._v(" "),_c('p',[_vm._v("\n    This list shows all the devices that have signed in with your account\n    recently.  If something here looks suspicious to you, you should\n    "),_c('router-link',{attrs:{"to":("/reset/" + (_vm.profile.email))}},[_vm._v("change your password")]),_vm._v("\n    and sign out everywhere.\n  ")],1),_vm._v(" "),_c('form-message',{attrs:{"severity":"warning","message":_vm.sessionsError}}),_vm._v(" "),_c('div',{staticClass:"wrap-mobile"},[_c('table',[_vm._m(0,false,false),_vm._v(" "),_vm._l((_vm.sessions),function(session){return _c('tr',[_c('td',[_vm._v("\n          "+_vm._s(session.device.browser)+"\n          on\n          "+_vm._s(session.device.model || session.device.os)+"\n          "+_vm._s(session.device.type || '')+"\n        ")]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(session.lastLoginRelative)+"\n        ")])])})],2)]),_vm._v(" "),_c('p',{staticClass:"text-center"},[(_vm.fetchMoreSessions)?_c('form-button',{on:{"click":_vm.fetchMoreSessions}},[_vm._v("\n      load more sessions\n    ")]):_vm._e(),_vm._v(" "),_c('form-button',{on:{"click":_vm.clearSessions}},[_vm._v("\n      Sign out everywhere\n    ")])],1),_vm._v(" "),_c('h2',{staticClass:"section"},[_vm._v("Danger zone")]),_vm._v(" "),_c('p',[_vm._v("\n    If you delete your account you will no longer be able to sign in to WElix,\n    and your access will be revoked in all WElix instances.\n  ")]),_vm._v(" "),(_vm.deleteConfirmed)?_c('form-message',{attrs:{"severity":"warning"}},[_vm._v("\n    Are you sure you want to delete your account? There is no way back from this!\n  ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-center"},[(!_vm.deleteConfirmed)?_c('form-button',{attrs:{"color":"orange"},on:{"click":function($event){_vm.deleteConfirmed = true}}},[_vm._v("\n      Delete account\n    ")]):_vm._e(),_vm._v(" "),(_vm.deleteConfirmed)?_c('form-button',{attrs:{"color":"orange"},on:{"click":_vm.deleteUser}},[_vm._v("\n      Yes I'm sure!\n    ")]):_vm._e(),_vm._v(" "),(_vm.deleteConfirmed)?_c('form-button',{on:{"click":function($event){_vm.deleteConfirmed = false}}},[_vm._v("\n      Wait, no!\n    ")]):_vm._e()],1)],1)}
var Profile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"row-header"},[_c('th',[_vm._v("Browser/device")]),_vm._v(" "),_c('th',[_vm._v("Last login")])])}]
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var components_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/components/Profile.vue
function Profile_injectStyle (ssrContext) {
  __webpack_require__("YQqd")
}
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = Profile_injectStyle
/* scopeId */
var Profile___vue_scopeId__ = "data-v-9171f742"
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  components_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var src_components_Profile = (Profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/Profile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var forms_Profile = ({
  components: {
    FormButton: components_elements_FormButton,
    FormField: components_elements_FormField
  },

  data: function data() {
    return {
      step: 'email',
      entered: {
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName
      }
    };
  },


  props: {
    email: String,
    emailDisabled: { type: Boolean, default: false },
    givenName: String,
    familyName: String,
    submitText: { type: String, default: 'Save' }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.step = '';

      if (!this.entered.email) {
        return this.$nextTick(function () {
          _this.step = 'email';
        });
      }

      if (!this.entered.givenName) {
        return this.$nextTick(function () {
          _this.step = 'givenName';
        });
      }

      if (!this.entered.familyName) {
        return this.$nextTick(function () {
          _this.step = 'familyName';
        });
      }

      return this.$emit('submit', {
        email: this.entered.email,
        givenName: this.entered.givenName,
        familyName: this.entered.familyName
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a506600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Profile.vue
var forms_Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-field',{attrs:{"type":"email","label":"Email","validate":/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,"required":true,"disabled":_vm.emailDisabled,"focus":_vm.step === 'email'},on:{"submit":function($event){_vm.step = 'givenName'}},model:{value:(_vm.entered.email),callback:function ($$v) {_vm.$set(_vm.entered, "email", $$v)},expression:"entered.email"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","label":"Given name","required":true,"focus":_vm.step === 'givenName'},on:{"submit":function($event){_vm.step = 'familyName'}},model:{value:(_vm.entered.givenName),callback:function ($$v) {_vm.$set(_vm.entered, "givenName", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"entered.givenName"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"text","label":"Family name","required":true,"focus":_vm.step === 'familyName'},on:{"submit":_vm.submit},model:{value:(_vm.entered.familyName),callback:function ($$v) {_vm.$set(_vm.entered, "familyName", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"entered.familyName"}}),_vm._v(" "),_c('form-button',{attrs:{"pull":"right","color":"blue"},on:{"click":_vm.submit}},[_vm._v("\n    "+_vm._s(_vm.submitText)+"\n  ")])],1)}
var forms_Profile_staticRenderFns = []
var forms_Profile_esExports = { render: forms_Profile_render, staticRenderFns: forms_Profile_staticRenderFns }
/* harmony default export */ var components_forms_Profile = (forms_Profile_esExports);
// CONCATENATED MODULE: ./src/components/forms/Profile.vue
var forms_Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var forms_Profile___vue_template_functional__ = false
/* styles */
var forms_Profile___vue_styles__ = null
/* scopeId */
var forms_Profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var forms_Profile___vue_module_identifier__ = null
var forms_Profile_Component = forms_Profile_normalizeComponent(
  forms_Profile,
  components_forms_Profile,
  forms_Profile___vue_template_functional__,
  forms_Profile___vue_styles__,
  forms_Profile___vue_scopeId__,
  forms_Profile___vue_module_identifier__
)

/* harmony default export */ var src_components_forms_Profile = (forms_Profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditProfile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var EditProfile = ({
  components: {
    Heading: elements_Heading,
    FormButton: components_elements_FormButton,
    FormMessage: components_elements_FormMessage,
    ProfileForm: src_components_forms_Profile
  },

  data: function data() {
    return {
      deleteConfirmed: false,
      profile: null,
      error: null
    };
  },
  created: function created() {
    var _this = this;

    getUserProfile({
      success: function success(result) {
        _this.profile = result;
      },
      error: function error(_error) {
        _this.error = _error;
      }
    });
  },


  methods: {
    updateProfile: function updateProfile(_ref) {
      var _this2 = this;

      var givenName = _ref.givenName,
          familyName = _ref.familyName;

      setUserProfile({
        given_name: givenName,
        family_name: familyName,
        success: function success() {
          _this2.$router.push('/');
        },
        error: function error(_error2) {
          _this2.error = _error2;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3f09bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditProfile.vue
var EditProfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heading',[_c('small',[_vm._v("Edit profile")])]),_vm._v(" "),_c('form-message',{attrs:{"severity":"warning","message":_vm.error}}),_vm._v(" "),(_vm.profile)?_c('profile-form',{attrs:{"email":_vm.profile.email,"givenName":_vm.profile.given_name,"familyName":_vm.profile.family_name,"emailDisabled":true,"submitText":"Save"},on:{"submit":_vm.updateProfile}}):_vm._e(),_vm._v(" "),_c('form-button',{attrs:{"pull":"left"},on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("\n    Cancel\n  ")]),_vm._v(" "),_vm._m(0,false,false)],1)}
var EditProfile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-disabled-note"},[_c('p',[_c('small',[_c('strong',[_vm._v("Note:")]),_vm._v("\n        Changing your email is unfortunately not yet possible via your account\n        settings, but you can get help with this by contacting support.\n      ")])])])}]
var EditProfile_esExports = { render: EditProfile_render, staticRenderFns: EditProfile_staticRenderFns }
/* harmony default export */ var components_EditProfile = (EditProfile_esExports);
// CONCATENATED MODULE: ./src/components/EditProfile.vue
function EditProfile_injectStyle (ssrContext) {
  __webpack_require__("5E/8")
}
var EditProfile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditProfile___vue_template_functional__ = false
/* styles */
var EditProfile___vue_styles__ = EditProfile_injectStyle
/* scopeId */
var EditProfile___vue_scopeId__ = "data-v-0d3f09bb"
/* moduleIdentifier (server only) */
var EditProfile___vue_module_identifier__ = null
var EditProfile_Component = EditProfile_normalizeComponent(
  EditProfile,
  components_EditProfile,
  EditProfile___vue_template_functional__,
  EditProfile___vue_styles__,
  EditProfile___vue_scopeId__,
  EditProfile___vue_module_identifier__
)

/* harmony default export */ var src_components_EditProfile = (EditProfile_Component.exports);

// CONCATENATED MODULE: ./src/rules/index.js


function isValidUrl(str) {
  return (/^https?:\/\/[a-z0-9]+([-.]{1}[a-z0-9]+)*(:\d+)?(\/[^?]*)?$/.test(str)
  );
}

function isValidCallbackUrl(str) {
  return isValidUrl(str) && validCallbacks.some(function (comp) {
    if (comp instanceof RegExp) {
      return comp.test(str);
    }

    return str === comp;
  });
}

function isValidEmail(str) {
  return (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(str)
  );
}

function sanitizePassword(str) {
  if (typeof str === 'string') {
    return str.replace(/\s/g, '');
  }
  return '';
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0081fec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FormLinks.vue
var FormLinks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"links"},[_vm._t("default")],2)}
var FormLinks_staticRenderFns = []
var FormLinks_esExports = { render: FormLinks_render, staticRenderFns: FormLinks_staticRenderFns }
/* harmony default export */ var FormLinks = (FormLinks_esExports);
// CONCATENATED MODULE: ./src/components/elements/FormLinks.vue
function FormLinks_injectStyle (ssrContext) {
  __webpack_require__("Wgo9")
}
var FormLinks_normalizeComponent = __webpack_require__("VU/8")
/* script */
var FormLinks___vue_script__ = null
/* template */

/* template functional */
var FormLinks___vue_template_functional__ = false
/* styles */
var FormLinks___vue_styles__ = FormLinks_injectStyle
/* scopeId */
var FormLinks___vue_scopeId__ = "data-v-c0081fec"
/* moduleIdentifier (server only) */
var FormLinks___vue_module_identifier__ = null
var FormLinks_Component = FormLinks_normalizeComponent(
  FormLinks___vue_script__,
  FormLinks,
  FormLinks___vue_template_functional__,
  FormLinks___vue_styles__,
  FormLinks___vue_scopeId__,
  FormLinks___vue_module_identifier__
)

/* harmony default export */ var elements_FormLinks = (FormLinks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Login = ({
  components: {
    FormButton: components_elements_FormButton,
    FormField: components_elements_FormField,
    FormLinks: elements_FormLinks
  },

  data: function data() {
    return {
      step: 'email',
      email: '',
      password: ''
    };
  },


  methods: {
    submit: function submit() {
      var _this = this;

      this.step = '';

      if (!this.email) {
        return this.$nextTick(function () {
          _this.step = 'email';
        });
      }

      if (!this.password) {
        return this.$nextTick(function () {
          _this.step = 'password';
        });
      }

      return this.$emit('submit', {
        email: this.email,
        password: sanitizePassword(this.password)
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e53975f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('form-field',{attrs:{"type":"email","label":"Email","validate":/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,"required":true,"focus":_vm.step === 'email'},on:{"submit":function($event){_vm.step = 'password'}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('form-field',{attrs:{"type":"password","label":"Password","required":true,"focus":_vm.step === 'password'},on:{"submit":_vm.submit},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('form-button',{attrs:{"pull":"right","color":"blue"},on:{"click":_vm.submit}},[_vm._v("Confirm")]),_vm._v(" "),_c('form-links',[_c('router-link',{attrs:{"to":("/reset/" + _vm.email)}},[_vm._v("Reset password")]),_vm._v(" "),_c('router-link',{attrs:{"to":("/signup/" + _vm.email)}},[_vm._v("Create account")])],1)],1)}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var forms_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/forms/Login.vue
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = null
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  forms_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var components_forms_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/zxcvbn/lib/main.js
var main = __webpack_require__("Omld");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/Password.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var forms_Password = ({
  components: {
    FormButton: components_elements_FormButton,
    FormField: components_elements_FormField,
    FormMessage: components_elements_FormMessage
  },

  data: function data() {
    return {
      password: '',
      score: 0,
      isShort: true,
      isEmpty: true,
      hasSpaces: false,
      crackTime: '',
      feedback: {
        pending: false,
        hint: ''
      }
    };
  },


  methods: {
    scheduleFeedback: function scheduleFeedback(_ref) {
      var warning = _ref.warning,
          suggestions = _ref.suggestions;

      var current = this.feedback;
      var hint = suggestions.reduce(function (str, suggestion) {
        return str + suggestion.replace(/[., ]*$/, '. ');
      }, warning && warning.replace(/[., ]*$/, '. '));

      if (current.hint) current.hint = '';
      if (current.pending) clearTimeout(current.pending);

      current.pending = setTimeout(function () {
        current.pending = false;
        current.hint = hint;
      }, 2000);
    },
    validatePassword: function validatePassword(password) {
      var sanitized = sanitizePassword(password);

      // guesstimate strength, penalize welix etc...
      var strength = main_default()(sanitized, ['WElix', 'wesustain', 'weac']);

      this.score = strength.score;
      this.crackTime = strength.crack_times_display.offline_slow_hashing_1e4_per_second;
      this.hasSpaces = /\S\s+\S/.test(password);
      this.isEmpty = !password;
      this.isShort = sanitized.length < 8;

      this.scheduleFeedback(strength.feedback);

      return strength.score >= 3 && !this.isShort;
    },
    submit: function submit() {
      if (this.password) {
        this.$emit('submit', {
          password: sanitizePassword(this.password)
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aba536e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Password.vue
var Password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    Enter the password you'd like to use to log in.\n  ")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('form-field',{attrs:{"type":"password","label":"Set password","required":true,"validate":_vm.validatePassword,"focus":true},on:{"submit":_vm.submit},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('div',{staticClass:"pw-strength",class:[("score-" + _vm.score), _vm.isShort && 'short']},[_c('div',{staticClass:"pw-strength__bar"},[_c('div',{staticClass:"pw-strength__fill",style:({ width: ((_vm.score*25) + "%") })}),_vm._v(" "),_vm._l(([25, 50, 75]),function(pos){return _c('div',{staticClass:"pw-strength__sep",style:({ left: ("calc(" + pos + "% - 2px)") })})})],2),_vm._v(" "),_c('small',[_vm._v("Estimated time to guess:")]),_vm._v(" "),(!_vm.isEmpty)?_c('strong',{staticClass:"pw-strength__time"},[_c('small',[_vm._v(_vm._s(_vm.crackTime))])]):_vm._e()]),_vm._v(" "),(_vm.feedback.hint)?_c('form-message',{attrs:{"severity":"information","message":_vm.feedback.hint}}):_vm._e(),_vm._v(" "),(_vm.hasSpaces)?_c('p',[_c('small',[_vm._v("\n      Note: Spaces in passwords are ignored, so you can type your password\n      with or without spaces when signing in.\n    ")])]):_vm._e(),_vm._v(" "),_c('form-button',{attrs:{"pull":"right","color":"blue"},on:{"click":_vm.submit}},[_vm._v("\n    Submit\n  ")])],1)}
var Password_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("\n      The password must be at least 8 characters and reasonably strong.\n      Symbols and numbers can help but are not required, multiple words are\n      better.\n    ")])])}]
var Password_esExports = { render: Password_render, staticRenderFns: Password_staticRenderFns }
/* harmony default export */ var components_forms_Password = (Password_esExports);
// CONCATENATED MODULE: ./src/components/forms/Password.vue
function Password_injectStyle (ssrContext) {
  __webpack_require__("mF6b")
}
var Password_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Password___vue_template_functional__ = false
/* styles */
var Password___vue_styles__ = Password_injectStyle
/* scopeId */
var Password___vue_scopeId__ = "data-v-2aba536e"
/* moduleIdentifier (server only) */
var Password___vue_module_identifier__ = null
var Password_Component = Password_normalizeComponent(
  forms_Password,
  components_forms_Password,
  Password___vue_template_functional__,
  Password___vue_styles__,
  Password___vue_scopeId__,
  Password___vue_module_identifier__
)

/* harmony default export */ var src_components_forms_Password = (Password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var components_Login = ({
  components: {
    Heading: elements_Heading,
    FormMessage: components_elements_FormMessage,
    LoginForm: components_forms_Login,
    PasswordForm: src_components_forms_Password
  },

  data: function data() {
    return {
      message: '',
      msgSeverity: 'information',
      forcedPwChangeMethod: false
    };
  },


  props: {
    redirect: { type: String, default: '/' }
  },

  methods: {
    login: function tryLogin(_ref) {
      var email = _ref.email,
          password = _ref.password;

      var self = this;

      login({
        password: password,
        username: email,
        success: function success() {
          return self.$router.push(self.redirect);
        },
        error: function error(msg) {
          self.message = msg;
          self.msgSeverity = 'warning';
        },
        forcepw: function forcepw(method) {
          return self.initPwChange(method);
        }
      });
    },

    initPwChange: function requestNewPassword(method) {
      this.message = 'A password reset is required, please enter a new password';
      this.msgSeverity = 'information';
      this.forcedPwChangeMethod = method;
    },

    completePwChange: function setNewPassword(_ref2) {
      var password = _ref2.password;

      this.forcedPwChangeMethod({
        newPassword: password,
        family_name: '',
        given_name: ''
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109cc890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var components_Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heading',[_vm._v("Sign in")]),_vm._v(" "),(_vm.message)?_c('form-message',{attrs:{"severity":_vm.msgSeverity,"message":_vm.message}}):_vm._e(),_vm._v(" "),(_vm.forcedPwChangeMethod)?_c('password-form',{on:{"submit":_vm.completePwChange}}):_c('login-form',{on:{"submit":_vm.login}})],1)}
var components_Login_staticRenderFns = []
var components_Login_esExports = { render: components_Login_render, staticRenderFns: components_Login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Login = (components_Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
var components_Login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var components_Login___vue_template_functional__ = false
/* styles */
var components_Login___vue_styles__ = null
/* scopeId */
var components_Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var components_Login___vue_module_identifier__ = null
var components_Login_Component = components_Login_normalizeComponent(
  components_Login,
  selectortype_template_index_0_src_components_Login,
  components_Login___vue_template_functional__,
  components_Login___vue_styles__,
  components_Login___vue_scopeId__,
  components_Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (components_Login_Component.exports);

// CONCATENATED MODULE: ./src/redirect/index.js






function redirect(_ref) {
  var next = _ref.next,
      payload = _ref.payload,
      state = _ref.state,
      token = _ref.token,
      errors = _ref.errors;

  var encodedErrors = errors && errors.length ? encodeURIComponent(stringify_default()(errors)) : null;

  var params = [state && 'state=' + encodeURIComponent(state), token && 'token=' + token, encodedErrors && 'errors=' + encodedErrors].filter(function (p) {
    return p;
  }).join('&');

  window.location = '' + next + (payload === 'fragment' ? '#' : '?') + params;
}

/**
 * Authorizes an external application by redirecting to a callback url `next`
 * with a token and an optional state parameter `state` in the query or fragment
 * part.
 *
 * The `responsetype` parameter must be either 'id-token' or 'access-token'.
 * The `payload` parameter must be either 'query' or 'fragment'.
 *
 * The `silent` parameter can be set to enable silent authorization, where also
 * errors result in a redirect to the callback url.
 *
 * Note: the error callback may be called multiple times with different errors,
 * but will not be called in silent mode.
 */
function authorize(_ref2) {
  var _ref2$silent = _ref2.silent,
      silent = _ref2$silent === undefined ? false : _ref2$silent,
      next = _ref2.next,
      state = _ref2.state,
      payload = _ref2.payload,
      responsetype = _ref2.responsetype,
      _error = _ref2.error;

  var log = createLogger('redirect.authorize');
  var silentErrors = [];

  var pushError = function pushError(err) {
    return silent ? silentErrors.push(err) : _error(err);
  };

  var ready = true;

  if (!isValidCallbackUrl(next)) {
    log.error({
      message: 'Authorize attempt with invalid callback url: "' + next + '".'
    });

    if (next) {
      pushError('The requested application to authorize for is not allowed.');
    } else {
      pushError('No application to authorize for.');
    }
    ready = false;
  }

  if (payload !== 'query' && payload !== 'fragment') {
    log.error({
      message: 'Authorize attempt with invalid payload type: "' + payload + '".'
    });

    pushError('Invalid payload type requested');
    ready = false;
  }

  if (responsetype !== 'access-token' && responsetype !== 'id-token') {
    log.error({
      message: 'Authorize attempt with invalid token type: "' + responsetype + '".'
    });

    pushError('Invalid token type requested');
    ready = false;
  }

  if (!ready) {
    if (silent) {
      redirect({ next: next, payload: payload, errors: silentErrors });
    }
    return;
  }

  var callOpts = {
    // token should be valid for at least 30 minutes
    minValidSeconds: 1800,
    error: function error(err) {
      if (silent) {
        redirect({ next: next, payload: payload, errors: [err] });
      } else {
        _error(err);
      }
    },
    success: function success(token) {
      log.trace({ message: 'User authorized for callback: "' + next + '".' }).then(function () {
        redirect({ next: next, payload: payload, token: token, state: state });
      });
    }
  };

  if (responsetype === 'access-token') getAccessToken(callOpts);else if (responsetype === 'id-token') getIdToken(callOpts);
}

/**
 * Logs out the current user and optionally redirects to a callback url `next`
 * with an optional state parameter `state` in the query part.
 *
 * Note: if no next url is given the `internalRedirect` callback is called.
 */
function signout(_ref3) {
  var next = _ref3.next,
      state = _ref3.state,
      internalRedirect = _ref3.internalRedirect,
      error = _ref3.error;

  var log = createLogger('redirect.signout');

  if (next && !isValidUrl(next)) {
    log.error({ message: 'Invalid redirect url at signout: "' + next + '".' });
    error(next + ' is not an accepted callback url.');
    return;
  }

  log.trace({ message: 'Post-signout redirect: "' + next + '".' }).then(function () {
    logout();

    if (next) {
      redirect({ next: next, state: state });
    } else {
      internalRedirect();
    }
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/Well.vue
//
//
//
//
//
//

/* harmony default export */ var Well = ({
  props: {
    severity: { type: String, default: '' }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372dfb18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Well.vue
var Well_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'well', _vm.severity ]},[_vm._t("default")],2)}
var Well_staticRenderFns = []
var Well_esExports = { render: Well_render, staticRenderFns: Well_staticRenderFns }
/* harmony default export */ var elements_Well = (Well_esExports);
// CONCATENATED MODULE: ./src/components/elements/Well.vue
function Well_injectStyle (ssrContext) {
  __webpack_require__("vhXF")
}
var Well_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Well___vue_template_functional__ = false
/* styles */
var Well___vue_styles__ = Well_injectStyle
/* scopeId */
var Well___vue_scopeId__ = "data-v-372dfb18"
/* moduleIdentifier (server only) */
var Well___vue_module_identifier__ = null
var Well_Component = Well_normalizeComponent(
  Well,
  elements_Well,
  Well___vue_template_functional__,
  Well___vue_styles__,
  Well___vue_scopeId__,
  Well___vue_module_identifier__
)

/* harmony default export */ var components_elements_Well = (Well_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Logout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Logout = ({
  components: {
    well: components_elements_Well
  },

  props: {
    callback: { type: String, default: '' },
    state: { type: String, default: '' }
  },

  data: function data() {
    return {
      error: null
    };
  },


  computed: {
    message: function statusMessage() {
      var successMessage = this.app ? 'Signing you out of ' + this.app + ', please wait...' : 'Signing you out, please wait...';

      return this.error ? 'Whoops, something went wrong. This is probably not your fault:' : successMessage;
    },

    app: function parseCallback() {
      var domain = /^https?:\/\/([^/]+)/.exec(this.callback);
      return domain ? domain[1] : this.callback;
    }
  },

  // trigger signout immediately
  mounted: function mounted() {
    var _this = this;

    signout({
      next: this.callback,
      state: this.state,
      error: function error(err) {
        _this.error = err;
      },
      internalRedirect: function internalRedirect() {
        _this.$router.push('/');
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e89f600","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
var Logout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('well',{attrs:{"severity":_vm.error ? 'warning' : ''}},[_c('p',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),(_vm.error)?_c('ul',[_c('li',[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")])]):_vm._e()])}
var Logout_staticRenderFns = []
var Logout_esExports = { render: Logout_render, staticRenderFns: Logout_staticRenderFns }
/* harmony default export */ var components_Logout = (Logout_esExports);
// CONCATENATED MODULE: ./src/components/Logout.vue
function Logout_injectStyle (ssrContext) {
  __webpack_require__("d1Og")
}
var Logout_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Logout___vue_template_functional__ = false
/* styles */
var Logout___vue_styles__ = Logout_injectStyle
/* scopeId */
var Logout___vue_scopeId__ = "data-v-6e89f600"
/* moduleIdentifier (server only) */
var Logout___vue_module_identifier__ = null
var Logout_Component = Logout_normalizeComponent(
  Logout,
  components_Logout,
  Logout___vue_template_functional__,
  Logout___vue_styles__,
  Logout___vue_scopeId__,
  Logout___vue_module_identifier__
)

/* harmony default export */ var src_components_Logout = (Logout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrivacyNotice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PrivacyNotice = ({
  components: {
    Heading: elements_Heading
  },

  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-472728b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivacyNotice.vue
var PrivacyNotice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heading',[_c('small',[_vm._v("Privacy notice")])]),_vm._v(" "),_c('p',[_vm._v("\n  We only collect the minimum amount of information that is required to\n  support the functionality of WElix. No information is shared with third\n  parties except in the cases listed below, or as required by law.\n  ")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false)],1)}
var PrivacyNotice_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n  In order to use the software you must consent to our data collection\n  practices as they are described here. You can of course change your mind,\n  and have the option to delete your account from the profile page at any\n  time. If we make changes to how we collect or handle personal data we will\n  ask for your consent again the next time you log in. If you have any\n  questions about this notice or our data collection practices you can contact\n  us by sending an email to "),_c('code',[_vm._v("support@welix.no")]),_vm._v(".\n  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy-details"},[_c('h2',[_vm._v("Personal data we collect")]),_vm._v(" "),_c('ul',{staticClass:"collection-list"},[_c('li',[_vm._v("\n        We ask for your "),_c('strong',[_vm._v("email and name")]),_vm._v(" when you sign up. This\n        information is available to WElix administrators and data owners, so\n        that they can manage access to their databases. We will never send you\n        emails that you have not requested except to notify you in the event\n        of a security breach.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        We link the "),_c('strong',[_vm._v("data you enter in WElix")]),_vm._v(" to your profile\n        and display your name in the change log of each item you add or\n        modify. The change log is visible to every user that has access to\n        view those items.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        The first time you log in with a new device we collect your "),_c('strong',[_vm._v("IP\n          address")]),_vm._v(" and the "),_c('strong',[_vm._v("browser and device")]),_vm._v(" you are\n        using. This information is only used to provide you with a list of\n        sessions on your profile page, and is intended as a way for you to\n        check for unauthorized use of your account. We do not share this\n        information with anyone.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        When you are logged in some of the "),_c('strong',[_vm._v("system logs")]),_vm._v(" we\n        collect are linked to your email address, so that we can more easily\n        find logs relevant to your issue when you need support. These logs\n        contain information about what you view and the actions you take in\n        the system. They are not shared with anyone, and we do not keep these\n        logs more than 6 months.\n      ")])]),_vm._v(" "),_c('h2',[_vm._v("Account deletion")]),_vm._v(" "),_c('p',[_vm._v("\n    You can delete your account from the profile page at any time. Your user\n    account will be completely deleted, along with your login history,\n    IP addresses and browser sessions.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n    However, your name and email address will continue to be associated with\n    data you have entered. This is required in order to maintain a full\n    historical account of the information in WElix.\n    ")])])}]
var PrivacyNotice_esExports = { render: PrivacyNotice_render, staticRenderFns: PrivacyNotice_staticRenderFns }
/* harmony default export */ var components_PrivacyNotice = (PrivacyNotice_esExports);
// CONCATENATED MODULE: ./src/components/PrivacyNotice.vue
function PrivacyNotice_injectStyle (ssrContext) {
  __webpack_require__("npr2")
}
var PrivacyNotice_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PrivacyNotice___vue_template_functional__ = false
/* styles */
var PrivacyNotice___vue_styles__ = PrivacyNotice_injectStyle
/* scopeId */
var PrivacyNotice___vue_scopeId__ = "data-v-472728b4"
/* moduleIdentifier (server only) */
var PrivacyNotice___vue_module_identifier__ = null
var PrivacyNotice_Component = PrivacyNotice_normalizeComponent(
  PrivacyNotice,
  components_PrivacyNotice,
  PrivacyNotice___vue_template_functional__,
  PrivacyNotice___vue_styles__,
  PrivacyNotice___vue_scopeId__,
  PrivacyNotice___vue_module_identifier__
)

/* harmony default export */ var src_components_PrivacyNotice = (PrivacyNotice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/Consent.vue
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Consent = ({
  components: {
    PrivacyNotice: src_components_PrivacyNotice,
    FormButton: components_elements_FormButton
  },

  data: function data() {
    return {};
  },


  methods: {
    submit: function submit() {
      this.$emit('submit', {
        consentDate: new Date().toISOString()
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1782be5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Consent.vue
var Consent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('privacy-notice'),_vm._v(" "),_c('form-button',{attrs:{"pull":"right","color":"blue"},on:{"click":_vm.submit}},[_vm._v("\n    I accept\n  ")])],1)}
var Consent_staticRenderFns = []
var Consent_esExports = { render: Consent_render, staticRenderFns: Consent_staticRenderFns }
/* harmony default export */ var forms_Consent = (Consent_esExports);
// CONCATENATED MODULE: ./src/components/forms/Consent.vue
function Consent_injectStyle (ssrContext) {
  __webpack_require__("B2D2")
}
var Consent_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Consent___vue_template_functional__ = false
/* styles */
var Consent___vue_styles__ = Consent_injectStyle
/* scopeId */
var Consent___vue_scopeId__ = "data-v-1782be5a"
/* moduleIdentifier (server only) */
var Consent___vue_module_identifier__ = null
var Consent_Component = Consent_normalizeComponent(
  Consent,
  forms_Consent,
  Consent___vue_template_functional__,
  Consent___vue_styles__,
  Consent___vue_scopeId__,
  Consent___vue_module_identifier__
)

/* harmony default export */ var components_forms_Consent = (Consent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/VerificationCode.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function strip(code) {
  return code.replace(/[- _.,+]/g, '');
}

/* harmony default export */ var VerificationCode = ({
  components: {
    FormButton: components_elements_FormButton,
    FormField: components_elements_FormField
  },

  data: function data() {
    return {
      code: '',
      focused: true
    };
  },


  methods: {
    validateCode: function validateCode(code) {
      return (/^\d{6}$/.test(strip(code))
      );
    },

    submit: function submit() {
      var _this = this;

      if (this.code) {
        this.$emit('submit', {
          code: strip(this.code)
        });
      } else {
        this.focused = false;
        this.$nextTick(function () {
          _this.focused = true;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302a245f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/VerificationCode.vue
var VerificationCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('form-field',{attrs:{"type":"tel","label":"Verification code","required":true,"validate":_vm.validateCode,"focus":_vm.focused},on:{"submit":_vm.submit},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),_c('form-button',{attrs:{"pull":"right","color":"blue"},on:{"click":_vm.submit}},[_vm._v("\n    Verify\n  ")])],1)}
var VerificationCode_staticRenderFns = []
var VerificationCode_esExports = { render: VerificationCode_render, staticRenderFns: VerificationCode_staticRenderFns }
/* harmony default export */ var forms_VerificationCode = (VerificationCode_esExports);
// CONCATENATED MODULE: ./src/components/forms/VerificationCode.vue
var VerificationCode_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VerificationCode___vue_template_functional__ = false
/* styles */
var VerificationCode___vue_styles__ = null
/* scopeId */
var VerificationCode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VerificationCode___vue_module_identifier__ = null
var VerificationCode_Component = VerificationCode_normalizeComponent(
  VerificationCode,
  forms_VerificationCode,
  VerificationCode___vue_template_functional__,
  VerificationCode___vue_styles__,
  VerificationCode___vue_scopeId__,
  VerificationCode___vue_module_identifier__
)

/* harmony default export */ var components_forms_VerificationCode = (VerificationCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Signup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var Signup = ({
  components: {
    Heading: elements_Heading,
    FormButton: components_elements_FormButton,
    FormMessage: components_elements_FormMessage,
    ConsentForm: components_forms_Consent,
    ProfileForm: src_components_forms_Profile,
    PasswordForm: src_components_forms_Password,
    CodeForm: components_forms_VerificationCode
  },

  data: function data() {
    return {
      step: 'profile',
      error: false,
      message: '',
      verifyMethod: null,
      userData: {}
    };
  },


  props: {
    email: { type: String, default: '' }
  },

  computed: {
    msgSeverity: function isError() {
      return this.error ? 'warning' : 'information';
    }
  },

  methods: {
    saveUserData: function saveUserData(_ref) {
      var email = _ref.email,
          givenName = _ref.givenName,
          familyName = _ref.familyName;

      this.userData = {
        email: email,
        given_name: givenName,
        family_name: familyName
      };
      this.step = 'consent';
    },
    saveConsent: function saveConsent(_ref2) {
      var consentDate = _ref2.consentDate;

      this.userData.consent_date = consentDate;
      this.step = 'password';
    },
    signup: function signup(_ref3) {
      var password = _ref3.password;

      var self = this;

      signup_signup(extends_default()({}, this.userData, {
        password: password,
        error: function error(err) {
          self.error = true;
          self.message = err;
        },
        verificationRequired: function verificationRequired(verifyMethod) {
          self.error = false;
          self.message = 'Verification code sent to ' + self.userData.email + ', ' + 'check your inbox and spam folder.';
          self.verifyMethod = verifyMethod;
          self.step = 'code';
        },
        success: function success() {
          self.error = false;
          self.step = 'done';
          self.message = 'Account created, you can now sign in.';
        }
      }));
    },
    submitCode: function submitCode(_ref4) {
      var code = _ref4.code;

      this.verifyMethod({ code: code });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f75ffca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup.vue
var Signup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.step !== 'consent')?_c('heading',[_c('small',[_vm._v("Create account")])]):_vm._e(),_vm._v(" "),(_vm.message)?_c('form-message',{attrs:{"severity":_vm.msgSeverity,"message":_vm.message}}):_vm._e(),_vm._v(" "),(_vm.step === 'profile')?_c('p',[_vm._v("\n    Before we can sign you up we need to know a few things about you…\n  ")]):_vm._e(),_vm._v(" "),(_vm.step === 'profile')?_c('profile-form',{attrs:{"email":_vm.email},on:{"submit":_vm.saveUserData}}):_vm._e(),_vm._v(" "),(_vm.step === 'consent')?_c('consent-form',{on:{"submit":_vm.saveConsent}}):_vm._e(),_vm._v(" "),(_vm.step === 'password')?_c('password-form',{on:{"submit":_vm.signup}}):_vm._e(),_vm._v(" "),(_vm.step === 'code')?_c('code-form',{on:{"submit":_vm.submitCode}}):_vm._e(),_vm._v(" "),(_vm.step === 'done')?_c('form-button',{attrs:{"focus":true,"color":"blue","pull":"right"},on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("\n    Sign in\n  ")]):_c('form-button',{attrs:{"pull":"left"},on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("\n    Cancel\n  ")])],1)}
var Signup_staticRenderFns = []
var Signup_esExports = { render: Signup_render, staticRenderFns: Signup_staticRenderFns }
/* harmony default export */ var components_Signup = (Signup_esExports);
// CONCATENATED MODULE: ./src/components/Signup.vue
var Signup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Signup___vue_template_functional__ = false
/* styles */
var Signup___vue_styles__ = null
/* scopeId */
var Signup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Signup___vue_module_identifier__ = null
var Signup_Component = Signup_normalizeComponent(
  Signup,
  components_Signup,
  Signup___vue_template_functional__,
  Signup___vue_styles__,
  Signup___vue_scopeId__,
  Signup___vue_module_identifier__
)

/* harmony default export */ var src_components_Signup = (Signup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Authorize.vue
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Authorize = ({
  components: {
    well: components_elements_Well
  },

  props: {
    callback: String,
    state: { type: String, default: '' },
    prompt: { type: String, default: '' },
    payload: { type: String, default: 'query' },
    responsetype: { type: String, default: 'id-token' }
  },

  data: function data() {
    return {
      errors: []
    };
  },


  // authorize immediately
  mounted: function mounted() {
    var _this = this;

    authorize({
      next: this.callback,
      state: this.state,
      silent: this.silent,
      payload: this.payload,
      responsetype: this.responsetype,
      error: function error(err) {
        _this.errors.push(err);
      }
    });
  },


  computed: {
    silent: function silent() {
      return this.prompt === 'none';
    },
    message: function message() {
      return this.errors.length ? 'Whoops, something went wrong, this is probably not your fault:' : 'Signing you in to ' + this.app + ', please wait\u2026';
    },
    app: function app() {
      var domain = /^https?:\/\/([^/]+)/.exec(this.callback);
      return domain ? domain[1] : this.callback;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d82d508","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Authorize.vue
var Authorize_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.silent)?_c('well',{attrs:{"severity":_vm.errors.length ? 'warning' : ''}},[_c('p',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),(_vm.errors.length)?_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_vm._v("\n      "+_vm._s(error)+"\n    ")])})):_vm._e()]):_vm._e()}
var Authorize_staticRenderFns = []
var Authorize_esExports = { render: Authorize_render, staticRenderFns: Authorize_staticRenderFns }
/* harmony default export */ var components_Authorize = (Authorize_esExports);
// CONCATENATED MODULE: ./src/components/Authorize.vue
function Authorize_injectStyle (ssrContext) {
  __webpack_require__("3L0a")
}
var Authorize_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Authorize___vue_template_functional__ = false
/* styles */
var Authorize___vue_styles__ = Authorize_injectStyle
/* scopeId */
var Authorize___vue_scopeId__ = "data-v-7d82d508"
/* moduleIdentifier (server only) */
var Authorize___vue_module_identifier__ = null
var Authorize_Component = Authorize_normalizeComponent(
  Authorize,
  components_Authorize,
  Authorize___vue_template_functional__,
  Authorize___vue_styles__,
  Authorize___vue_scopeId__,
  Authorize___vue_module_identifier__
)

/* harmony default export */ var src_components_Authorize = (Authorize_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AskConsent.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var AskConsent = ({
  components: {
    Heading: elements_Heading,
    FormButton: components_elements_FormButton,
    FormMessage: components_elements_FormMessage,
    ConsentForm: components_forms_Consent
  },

  created: function created() {
    var _this = this;

    getConsentDate(function (date) {
      _this.last_consent_date = date;
    });
  },
  data: function data() {
    return {
      last_consent_date: '9999',
      error: null
    };
  },


  computed: {
    updates: function updates() {
      var _this2 = this;

      return privacyNoticeUpdates.filter(function (x) {
        return !_this2.last_consent_date || x.date > _this2.last_consent_date;
      });
    }
  },

  props: {
    redirect: { type: String, default: '/' }
  },

  methods: {
    saveConsent: function saveConsent(_ref) {
      var _this3 = this;

      var consentDate = _ref.consentDate;

      setConsentDate({
        consent_date: consentDate,
        success: function success() {
          return _this3.$router.replace(_this3.redirect);
        },
        error: function error(err) {
          _this3.error = err;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4336cdf5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AskConsent.vue
var AskConsent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heading',[_c('small',[_vm._v("Updated privacy notice")])]),_vm._v(" "),_c('p',[_vm._v("\n  Hi there, we've made some changes since the last time you were here:\n  ")]),_vm._v(" "),_c('ul',{staticClass:"privacy-update-list"},_vm._l((_vm.updates),function(update){return _c('li',[_c('div',{staticClass:"privacy-update-date"},[_vm._v(_vm._s(update.date)+":")]),_vm._v(" "),_vm._l((update.notice),function(text){return _c('p',[_vm._v("\n      "+_vm._s(text)+"\n      ")])})],2)})),_vm._v(" "),_c('p',[_vm._v("\n  Please have a look at the full privacy notice below to learn about how we\n  handle your personal information and consent to our updated practices before\n  you continue to use WElix.\n  ")]),_vm._v(" "),_c('hr',{staticClass:"rule"}),_vm._v(" "),_c('consent-form',{on:{"submit":_vm.saveConsent}}),_vm._v(" "),_c('form-button',{attrs:{"pull":"left"},on:{"click":function($event){_vm.$router.push('/')}}},[_vm._v("\n    Cancel\n  ")]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),(_vm.error)?_c('form-message',{attrs:{"severity":"warning","message":_vm.error}}):_vm._e()],1)}
var AskConsent_staticRenderFns = []
var AskConsent_esExports = { render: AskConsent_render, staticRenderFns: AskConsent_staticRenderFns }
/* harmony default export */ var components_AskConsent = (AskConsent_esExports);
// CONCATENATED MODULE: ./src/components/AskConsent.vue
function AskConsent_injectStyle (ssrContext) {
  __webpack_require__("D32g")
}
var AskConsent_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AskConsent___vue_template_functional__ = false
/* styles */
var AskConsent___vue_styles__ = AskConsent_injectStyle
/* scopeId */
var AskConsent___vue_scopeId__ = "data-v-4336cdf5"
/* moduleIdentifier (server only) */
var AskConsent___vue_module_identifier__ = null
var AskConsent_Component = AskConsent_normalizeComponent(
  AskConsent,
  components_AskConsent,
  AskConsent___vue_template_functional__,
  AskConsent___vue_styles__,
  AskConsent___vue_scopeId__,
  AskConsent___vue_module_identifier__
)

/* harmony default export */ var src_components_AskConsent = (AskConsent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/RequestPasswordReset.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var RequestPasswordReset = ({
  components: {
    FormButton: components_elements_FormButton,
    FormField: components_elements_FormField
  },

  data: function data() {
    return {
      enteredEmail: this.email
    };
  },


  props: {
    email: String
  },

  methods: {
    submit: function submit() {
      if (this.enteredEmail) {
        this.$emit('submit', {
          email: this.enteredEmail
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13d3f428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/RequestPasswordReset.vue
var RequestPasswordReset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_vm._m(0,false,false),_vm._v(" "),_c('form-field',{attrs:{"type":"email","label":"Email","validate":/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,"required":true,"focus":true},on:{"submit":_vm.submit},model:{value:(_vm.enteredEmail),callback:function ($$v) {_vm.enteredEmail=$$v},expression:"enteredEmail"}}),_vm._v(" "),_c('form-button',{attrs:{"color":"blue","pull":"right"},on:{"click":_vm.submit}},[_vm._v("\n    Request code\n  ")])],1)}
var RequestPasswordReset_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("\n      Before changing the password we'll send you a one time code to verify\n      ownership of your email address.\n    ")])])}]
var RequestPasswordReset_esExports = { render: RequestPasswordReset_render, staticRenderFns: RequestPasswordReset_staticRenderFns }
/* harmony default export */ var forms_RequestPasswordReset = (RequestPasswordReset_esExports);
// CONCATENATED MODULE: ./src/components/forms/RequestPasswordReset.vue
var RequestPasswordReset_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var RequestPasswordReset___vue_template_functional__ = false
/* styles */
var RequestPasswordReset___vue_styles__ = null
/* scopeId */
var RequestPasswordReset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RequestPasswordReset___vue_module_identifier__ = null
var RequestPasswordReset_Component = RequestPasswordReset_normalizeComponent(
  RequestPasswordReset,
  forms_RequestPasswordReset,
  RequestPasswordReset___vue_template_functional__,
  RequestPasswordReset___vue_styles__,
  RequestPasswordReset___vue_scopeId__,
  RequestPasswordReset___vue_module_identifier__
)

/* harmony default export */ var components_forms_RequestPasswordReset = (RequestPasswordReset_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PasswordReset.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var PasswordReset = ({
  components: {
    Heading: elements_Heading,
    FormButton: components_elements_FormButton,
    FormMessage: components_elements_FormMessage,
    RequestForm: components_forms_RequestPasswordReset,
    CodeForm: components_forms_VerificationCode,
    PasswordForm: src_components_forms_Password
  },

  data: function data() {
    return {
      message: '',
      error: false,
      step: 'email',
      username: null,
      code: null
    };
  },


  props: {
    email: { type: String }
  },

  computed: {
    msgSeverity: function isError() {
      return this.error ? 'warning' : 'information';
    }
  },

  methods: {
    requestEmail: function requestEmail(_ref) {
      var email = _ref.email;

      var self = this;
      this.username = email;

      requestReset({
        username: this.username,
        success: function success() {
          self.message = 'Verification code sent to ' + email + ', ' + 'check your inbox and spam folder.';
          self.error = false;
          self.step = 'code';
        },
        error: function error(err) {
          self.error = true;
          self.message = err;
        }
      });
    },

    storeCode: function storeCode(_ref2) {
      var code = _ref2.code;

      this.code = code;
      this.step = 'password';
      this.message = '';
      this.error = false;
    },

    changePassword: function changePassword(_ref3) {
      var password = _ref3.password;

      var self = this;

      completeReset({
        password: password,
        username: this.username,
        code: this.code,
        success: function success() {
          logout();

          self.step = 'done';
          self.message = 'Password changed. Sign in with your new password ' + 'to verify that you typed it correctly. ' + 'If not you can reset again.';
          self.error = false;
        },
        error: function error(err) {
          // check which step to revert to?
          self.step = 'code';
          self.message = err;
          self.error = true;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aa29265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordReset.vue
var PasswordReset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heading',[_c('small',[_vm._v("Reset password")])]),_vm._v(" "),(_vm.message)?_c('form-message',{attrs:{"severity":_vm.msgSeverity,"message":_vm.message}}):_vm._e(),_vm._v(" "),(_vm.step === 'email')?_c('request-form',{attrs:{"email":_vm.email},on:{"submit":_vm.requestEmail}}):_vm._e(),_vm._v(" "),(_vm.step === 'code')?_c('code-form',{on:{"submit":_vm.storeCode}}):_vm._e(),_vm._v(" "),(_vm.step === 'password')?_c('password-form',{on:{"submit":_vm.changePassword}}):_vm._e(),_vm._v(" "),(_vm.step === 'done')?_c('form-button',{attrs:{"focus":true,"color":"blue","pull":"right"},on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("\n    Sign in\n  ")]):_c('form-button',{attrs:{"pull":"left"},on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._v("\n    Cancel\n  ")])],1)}
var PasswordReset_staticRenderFns = []
var PasswordReset_esExports = { render: PasswordReset_render, staticRenderFns: PasswordReset_staticRenderFns }
/* harmony default export */ var components_PasswordReset = (PasswordReset_esExports);
// CONCATENATED MODULE: ./src/components/PasswordReset.vue
var PasswordReset_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PasswordReset___vue_template_functional__ = false
/* styles */
var PasswordReset___vue_styles__ = null
/* scopeId */
var PasswordReset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PasswordReset___vue_module_identifier__ = null
var PasswordReset_Component = PasswordReset_normalizeComponent(
  PasswordReset,
  components_PasswordReset,
  PasswordReset___vue_template_functional__,
  PasswordReset___vue_styles__,
  PasswordReset___vue_scopeId__,
  PasswordReset___vue_module_identifier__
)

/* harmony default export */ var src_components_PasswordReset = (PasswordReset_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js
















vue_runtime_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: routerMode,
  routes: [{
    path: '/',
    name: 'Profile',
    components: {
      layout: layouts_Dialogue,
      content: src_components_Profile
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/edit',
    name: 'EditProfile',
    components: {
      layout: layouts_Dialogue,
      content: src_components_EditProfile
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/ask-consent',
    name: 'AskConsent',
    components: {
      layout: layouts_Dialogue,
      content: src_components_AskConsent
    },
    props: {
      content: function content(route) {
        return {
          redirect: route.query.redirect
        };
      }
    },
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/authorize',
    name: 'Authorize',
    components: {
      layout: layouts_Centered,
      content: src_components_Authorize
    },
    props: {
      content: function content(route) {
        return {
          responsetype: route.query.responsetype,
          callback: route.query.callback,
          payload: route.query.payload,
          prompt: route.query.prompt,
          state: route.query.state
        };
      }
    },
    meta: {
      requiresAuth: function requiresAuth(_ref) {
        var query = _ref.query;
        return query.prompt !== 'none';
      },
      checkConsent: function checkConsent(_ref2) {
        var query = _ref2.query;
        return query.prompt !== 'none';
      }
    }
  }, {
    path: '/login',
    name: 'Login',
    components: {
      layout: layouts_Dialogue,
      content: src_components_Login
    },
    props: {
      content: function content(route) {
        return {
          redirect: route.query.redirect
        };
      }
    }
  }, {
    path: '/reset/:email?',
    name: 'PasswordReset',
    components: {
      layout: layouts_Dialogue,
      content: src_components_PasswordReset
    },
    props: { content: true }
  }, {
    path: '/signup/:email?',
    name: 'Signup',
    components: {
      layout: layouts_Dialogue,
      content: src_components_Signup
    },
    props: { content: true }
  }, {
    path: '/logout',
    name: 'Logout',
    components: {
      layout: layouts_Centered,
      content: src_components_Logout
    },
    props: {
      content: function content(route) {
        return {
          callback: route.query.callback,
          state: route.query.state
        };
      }
    }
  }, {
    path: '/privacy-notice',
    name: 'PrivacyNotice',
    components: {
      layout: layouts_Dialogue,
      content: src_components_PrivacyNotice
    }
  }]
});

router.beforeResolve(function (to, from, next) {
  var result = function result(prop) {
    return typeof prop === 'function' ? prop(to) : prop;
  };
  var mustAuthenticate = to.matched.some(function (record) {
    return result(record.meta.requiresAuth);
  });
  var mustConsent = to.matched.some(function (record) {
    return result(record.meta.checkConsent);
  });

  if (mustAuthenticate || mustConsent) {
    // this route requires auth or consent, check if logged in
    // if not, redirect to login page.
    return isAuthenticated(function (authenticated) {
      if (!authenticated) {
        next({ path: '/login', query: { redirect: to.fullPath } });
      } else if (mustConsent) {
        getConsentDate(function (date) {
          // dates in ISO8601 are sortable strings
          if (!date || date < privacyNoticeDate) {
            next({
              path: '/ask-consent',
              query: { redirect: to.fullPath }
            });
          } else {
            next();
          }
        });
      } else {
        next();
      }
    });
  }

  return next(); // make sure to always call next()!
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/main.js




vue_runtime_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_runtime_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "Wgo9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YQqd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1Og":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dhOH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eaxF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hrNr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mF6b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "npr2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vhXF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cd88f67f9184017cea11.js